import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=2cc900b3&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=2cc900b3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc900b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc900b3')) {
      api.createRecord('2cc900b3', component.options)
    } else {
      api.reload('2cc900b3', component.options)
    }
    module.hot.accept("./Paginator.vue?vue&type=template&id=2cc900b3&scoped=true", function () {
      api.rerender('2cc900b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/Paginator.vue"
export default component.exports